import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { BarChart3 } from "lucide-react";

const COLS = [["total", "Total"], ["today", "Today"], ["week", "Last 7 days"], ["month", "This month"], ["admitted", "Admitted"]];

/** Source-wise lead counts for the dashboard. */
export default function SourceStats() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/dashboard/sources").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  const max = Math.max(...rows.map((r) => r.total), 1);
  return (
    <div className="mt-6 bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="source-stats">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-bold text-[#312E81]">Source-wise Leads</h3>
        <BarChart3 className="w-4 h-4 text-[#4F46E5]" />
      </div>
      {rows.length === 0 ? <div className="text-sm text-slate-400 py-6 text-center">No leads yet</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[11px] uppercase tracking-wider text-slate-400 text-left">
              <th className="py-2 pr-3">Source</th><th className="py-2 pr-3 w-1/3"></th>
              {COLS.map(([k, l]) => <th key={k} className="py-2 px-2 text-right">{l}</th>)}
              <th className="py-2 pl-2 text-right">Conversion</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.source} onClick={() => navigate(`/leads?source=${encodeURIComponent(r.source)}`)} className="border-t border-slate-100 hover:bg-indigo-50/40 cursor-pointer" data-testid={`source-row-${r.source.replace(/\s+/g, "-").toLowerCase()}`}>
                  <td className="py-2 pr-3 font-semibold text-slate-700 whitespace-nowrap">{r.source}</td>
                  <td className="py-2 pr-3"><div className="h-2.5 bg-slate-100 rounded-full overflow-hidden"><div className="h-full bg-gradient-to-r from-[#312E81] to-[#6366F1] rounded-full" style={{ width: `${Math.max((r.total / max) * 100, 3)}%` }} /></div></td>
                  {COLS.map(([k]) => <td key={k} className={`py-2 px-2 text-right tabular-nums ${k === "total" ? "font-bold text-[#312E81]" : "text-slate-600"}`}>{r[k]}</td>)}
                  <td className="py-2 pl-2 text-right text-emerald-700 font-semibold tabular-nums">{r.total ? `${((r.admitted / r.total) * 100).toFixed(1)}%` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
